import { LogLevel } from '../app/core/logging';

export class EnvironmentConfig {
  public name: string;
  public production: boolean;
  public otaStorageBucket: string;
  public firebase: FirebaseConfig;
  public logging: LoggingConfig;
}

export class FirebaseConfig {
  public apiKey: string;
  public authDomain: string;
  public databaseURL: string;
  public projectId: string;
  public storageBucket: string;
  public messagingSenderId: string;
}

export class LoggingConfig {
  public logLevel: LogLevel;
  public zones: Set<string>;
}
